// Contextual help button — a small ❓ icon next to a page heading that
// links to the relevant `/help#slug` section.  Every major page uses this
// so users can discover features without hunting through the manual.
//
// Usage:
//   <PageHeader title="Matters">
//     <HelpButton slug="matters" />
//   </PageHeader>
//
// Or inline:
//   <h1>Matters <HelpButton slug="matters" /></h1>
//
// The button is invisible on print (via `no-print`) so it doesn't clutter
// printed pages.

import { Link } from 'react-router-dom'

export default function HelpButton ({ slug, tooltip = null, className = '' }) {
  const label = tooltip || `Open help for this page`
  return (
    <Link
      to={`/help#${slug}`}
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center w-6 h-6 ml-2 text-gray-400 hover:text-primary-600 hover:bg-primary-50 rounded-full text-sm no-print transition-colors align-middle ${className}`}
    >
      <span aria-hidden="true">?</span>
    </Link>
  )
}
